let locationRequest;

const dialCodes = {
  ae: "+971",
  au: "+61",
  ca: "+1",
  gb: "+44",
  in: "+91",
  us: "+1",
};

export function dialCodeForCountry(countryCode) {
  return dialCodes[countryCode?.toLowerCase()] || "+1";
}

export function getClientLocation() {
  if (!locationRequest) {
    locationRequest = fetch("/api/client-location", {
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Location lookup failed");
        return response.json();
      })
      .catch(() => ({
        country_code: "",
        country_name: "",
        ip: "",
      }));
  }

  return locationRequest;
}
